/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_04_CategoryInputs */

const en_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landscape`)
};

const ar_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مناظر طبيعية`)
};

const bn_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ল্যান্ডস্কেপ`)
};

const de_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landschaft`)
};

const es_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisaje`)
};

const fr_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paysage`)
};

const pt_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisagem`)
};

const zh_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`景观`)
};

const tr_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manzara`)
};

const ru_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пейзаж`)
};

const pl_elastic_gallery_item_04_category = /** @type {(inputs: Elastic_Gallery_Item_04_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krajobraz`)
};

/**
* | output |
* | --- |
* | "Landscape" |
*
* @param {Elastic_Gallery_Item_04_CategoryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_04_category = /** @type {((inputs?: Elastic_Gallery_Item_04_CategoryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_04_CategoryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_04_category(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_04_category(inputs)
	if (locale === "de") return de_elastic_gallery_item_04_category(inputs)
	if (locale === "es") return es_elastic_gallery_item_04_category(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_04_category(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_04_category(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_04_category(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_04_category(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_04_category(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_04_category(inputs)
	return en_elastic_gallery_item_04_category(inputs)
});